<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import CommunicationLogRequest from 'App/users/services/CommunicationLogService';
import DataTableShortDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableShortDateColumn.vue';
import DataTableHoursTableVue from '@/app/arch/components/data-table/DataTableColumns/DataTableHoursTable.vue';

export default {
  name: 'UserCommunicationList',
  extends: CrudListVue,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    requestClass: CommunicationLogRequest,
    hideEdit: true,
    hideDelete: true,
    headers: [
      {
        text: 'Título',
        value: 'title',
      },
      {
        value: 'type',
        text: 'Tipo',
      },
      {
        text: 'Mensagem',
        value: 'message',
      },
      {
        value: 'sendedDate',
        text: 'Data do envio',
        component: DataTableShortDateColumnVue,
      },
      {
        value: 'sendedTime',
        text: 'Hora do envio',
        component: DataTableHoursTableVue,
      },
    ],
  }),
  computed: {
    clientId() {
      return this.value;
    },
  },
  methods: {
    prepareRequest(params) {
      return this.requestClass.list(
        this.clientId,
        params,
      );
    },
  },
};
</script>
